import React from "react";
import { etiquetaCopia, formatearFechaHora } from "../../../utils/copiasPrestamo";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import * as XLSX from "xlsx";
import { format } from "date-fns";
import { RiFileExcel2Fill } from "react-icons/ri";
import { obtenerTodosLosPrestamos } from "../../../services/PrestamosService";
import './index.css'; 

// Si ya tienes un formateador propio úsalo; si no, este fallback sencillo:
const safeDate = (d) => (d ? new Date(d) : null);
const fmtDate = (d) => (safeDate(d) ? format(new Date(d), "dd/MM/yyyy") : "N/A");

const DownloadPrestamosExcel = () => {
  const MySwal = withReactContent(Swal);

  const handleDownloadExcel = async () => {
    const { isConfirmed, value: prestamosData } = await MySwal.fire({
      title: "¿Descargar préstamos en Excel?",
      text: "Se exportarán todos los préstamos del sistema.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, descargar",
      confirmButtonColor: "#21807C",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const data = await obtenerTodosLosPrestamos();
          return data;
        } catch (error) {
          Swal.showValidationMessage(
            `No se pudieron obtener los préstamos: ${
              error?.response?.data?.mensaje || error?.message || String(error)
            }`
          );
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });

    if (!isConfirmed || !prestamosData) return;

    try {
      await generarExcelPrestamos(prestamosData);
      Swal.fire({
        title: "¡Excel generado!",
        text: "El archivo se ha descargado correctamente.",
        icon: "success",
        confirmButtonColor: "#21807C",
      });
    } catch (e) {
      console.error("Error al generar el Excel de préstamos:", e);
      Swal.fire({
        title: "Error",
        text: "No se pudo generar el Excel.",
        icon: "error",
        confirmButtonColor: "#21807C",
      });
    }
  };

  const generarExcelPrestamos = async (data) => {
    // Mapeo seguro de campos
    const rows = (Array.isArray(data) ? data : []).map((p) => {
      const libro = p?.libro || {};
      const usuario = p?.usuario || {};
      const entrega = p?.personalEntrega || null;
      const recepcion = p?.personalRecepcion || null;

      const ubic = libro?.ubicacion;
      const ubicacionStr = ubic
        ? `Área: ${ubic.area ?? "N/A"}, Estante: ${ubic.numEstante ?? "N/A"}, Repisa: ${ubic.numRepisa ?? "N/A"}`
        : "N/A";

      return {
        "ID Préstamo": p?.idPrestamo ?? "N/A",
        "Código de Retiro": p?.codigoRetiro ?? "N/A",
        "Código de Copia": etiquetaCopia(p),
        "Fecha de entrega": formatearFechaHora(p?.fechaEntrega),
        "Fecha de recepción": formatearFechaHora(p?.fechaRecepcion),
        Estado: p?.estado ?? "N/A",
        "CIF Estudiante": usuario?.cif ?? "N/A",
        Estudiante: usuario?.nombreCompleto ?? "N/A",
        Libro: libro?.titulo ?? "N/A",
        ISBN: libro?.isbn ?? "N/A",
        "Fecha de solicitud": fmtDate(p?.fechaSolicitud),
        "Fecha límite de devolución": fmtDate(p?.fechaLimiteDevolucion),
        "Num. Renovaciones": p?.numRenovaciones ?? 0,
        "Ubicación del Libro": ubicacionStr,
        "Personal de Entrega": entrega?.nombreCompleto ?? "--",
        "Personal de Recepción": recepcion?.nombreCompleto ?? "--",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Préstamos");

    // Anchos de columna (opcional, para mejor lectura)
    const headers = Object.keys(rows[0] || {});
    worksheet["!cols"] = headers.map((h) => {
      const base = 14;
      // ajuste ligero para algunas columnas
      if (["Libro", "Estudiante", "Ubicación del Libro"].includes(h)) return { wch: 32 };
      if (["Fecha de solicitud", "Fecha límite de devolución"].includes(h)) return { wch: 18 };
      return { wch: base };
    });

    const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Prestamos_${format(new Date(), "dd-MM-yyyy")}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <button onClick={handleDownloadExcel} className="download-prestamos-button">
      Préstamos en Excel
      <RiFileExcel2Fill size={20} />
    </button>
  );
};

export default DownloadPrestamosExcel;
